module.exports = addressAutocomplete;

function addressAutocomplete(element, callback) {
    const componentForm = [
        'location',
        'locality',
        'administrative_area_level_1',
        'country',
        'postal_code'
    ];

    const autocomplete = new google.maps.places.Autocomplete(element);

    autocomplete.addListener('place_changed', function () {
        const place = autocomplete.getPlace();

        if (!place.geometry) {
            return;
        }

        callback(extractAddress(place));
    });

    function extractAddress(place) {
        const addressNameFormat = {
          'street_number': 'short_name',
          'route': 'long_name',
          'locality': 'long_name',
          'administrative_area_level_1': 'short_name',
          'country': 'long_name',
          'postal_code': 'short_name',
        };

        const getAddressComp = function (type) {
          for (const component of place.address_components) {
            if (component.types[0] === type) {
              return component[addressNameFormat[type]];
            }
          }
          return '';
        };

        return {
            address: `${getAddressComp('street_number')} ${getAddressComp('route')}`,
            city: getAddressComp('locality'),
            state: getAddressComp('administrative_area_level_1'),
            postal_code: getAddressComp('postal_code'),
            country: getAddressComp('country')
        };
    }
}

window.gm_authFailure = function () {
    const addr = document.getElementById('id_address1');
    addr.disabled = false;
    addr.placeholder = 'Street address, P.O. box';
    addr.style = {};

    const $item = $(addr).parents('[data-form="address"]');
    const countrySection = $item.find('[data-form-section="country"]');
    const afterCountry = $item.find('[data-form-section="after-country"]');

    $(countrySection).insertBefore(afterCountry);

    return false;
}